module.exports = __webpack_public_path__ + "img/6.f797af43.png";